import { useEffect, useState } from "react";

export function useBusinessTheme() {
  const [businessName, setBusinessName] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const business = sessionStorage.getItem("organizationName") || "";
    setBusinessName(business);

    const themeKeys = [
      { key: "background_color", cssVar: "--background-color" },
      { key: "font_color", cssVar: "--font-color" },
      { key: "font_family", cssVar: "--fontfamily" },
    ];

    themeKeys.forEach(({ key, cssVar }) => {
      const value = sessionStorage.getItem(`${key}${business}`);
      if (value) {
        document.documentElement.style.setProperty(cssVar, value);
      }
    });

    setLoading(false); // ✅ done loading
  }, []);

  return { businessName, loading }; // ✅ return object
}
